var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightMachineAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14C8.75 12.2051 10.2051 10.75 12 10.75C13.7949 10.75 15.25 12.2051 15.25 14C15.25 15.7949 13.7949 17.25 12 17.25C10.2051 17.25 8.75 15.7949 8.75 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.25H21C21.4142 3.25 21.75 3.58579 21.75 4C21.75 4.41421 21.4142 4.75 21 4.75H17.75V7H18.2654C19.2607 7 20.1045 7.73186 20.2453 8.71716L21.6739 18.7172C21.846 19.922 20.9111 21 19.694 21H19C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21H7C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21H4.30601C3.08891 21 2.15399 19.922 2.32611 18.7172L3.75468 8.71716C3.89544 7.73186 4.73928 7 5.73458 7H6.25V4.75H3C2.58579 4.75 2.25 4.41421 2.25 4C2.25 3.58579 2.58579 3.25 3 3.25ZM7.75 4.75V7H16.25V4.75H7.75ZM12 9.25C9.37664 9.25 7.24999 11.3766 7.24999 14C7.24999 16.6234 9.37664 18.75 12 18.75C14.6233 18.75 16.75 16.6234 16.75 14C16.75 11.3766 14.6233 9.25 12 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightMachineAlt);
export default __webpack_public_path__ + "static/media/weight-machine-alt.aaa7e1ba1a567769a1c2c7affe9d4468.svg";
export { ForwardRef as ReactComponent };